<ng-container *ngIf="!!formGroup && !!formGroup.get(formControlName)">
  <div class="p-float-label">
    <p-multiSelect
      class="p-inputwrapper-focus"
      [options]="options"
      [(ngModel)]="selectedObjectsToDisplay"
      [placeholder]="placeholder"
      [optionLabel]="optionLabel"
      (onChange)="onSelect($event)"
    >
    </p-multiSelect>
    <label [ngClass]="{ required: required, 'label-disabled': isDisabled }">{{ name }}</label>
  </div>
</ng-container>
